import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
  UncontrolledAccordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Button,
} from "reactstrap";
import "../../css/promo-bundle.css";
import banner from "../../assets/broadband/sg60/banner.png";
import mobileBanner from "../../assets/broadband/sg60/mobile-banner.png";
import p1 from "../../assets/broadband/sg60/1.png";
import p2 from "../../assets/broadband/sg60/2.png";
import p3 from "../../assets/broadband/sg60/3.png";
import p4 from "../../assets/broadband/sg60/4.png";

class LazyImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: props.placeholder || "", // show placeholder or nothing initially
    };
  }

  componentDidMount() {
    const img = new Image();
    img.src = this.props.src;
    img.onload = () => this.setState({ src: this.props.src });
    img.onerror = () => {
      if (this.props.fallback) {
        this.setState({ src: this.props.fallback });
      }
    };
  }

  render() {
    const { alt, className, style } = this.props;
    return (
      <img src={this.state.src} alt={alt} className={className} style={style} />
    );
  }
}

class Sg60 extends Component {
  constructor() {
    super();
    this.accordionRef = React.createRef();
  }

  render() {
    return (
      <div
        style={{
          backgroundColor: "#fff",
          fontFamily: "Figtree, sans-serif",
          color: "#000",
        }}
      >
        <Row className="text-center my-5">
          <Col>
            <img
              src={
                window.innerWidth >= 1000 || window.innerHeight >= 1125
                  ? banner
                  : mobileBanner
              }
              className="img-fluid"
              style={{ width: "80%", borderRadius: 10 }}
            />
          </Col>
        </Row>

        <Row className="text-center my-5">
          <Col>
            <h2 style={{ fontWeight: 700, fontSize: "clamp(24px, 3vw, 32px)" }}>
              Get ready to celebrate SG60 the SIMBA way!
            </h2>
            <p style={{ fontSize: 16, width: "80%", margin: "10px auto" }}>
              As part of our SG60 Promo, we're bringing you crazy-good deals on
              our 5G mobile.Whether you're switching to SIMBA 5G, recharge your
              wallet or getting a new 5G smartphone, now's the perfect time to
              enjoy more for less!
            </p>
            <p style={{ fontSize: 16, width: "80%", margin: "10px auto" }}>
              Come join us at{" "}
              <a
                href="https://simba.sg/collect"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#7B61FF",
                  textDecorationStyle: "solid",
                }}
              >
                Service Centres
              </a>{" "}
              &{" "}
              <a
                href="https://simba.sg/walk-in"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#7B61FF",
                  textDecorationStyle: "solid",
                }}
              >
                Authorised Dealers
              </a>{" "}
              today!
            </p>
          </Col>
        </Row>

        <Row
          className="text-center"
          style={{ width: "100%", margin: "auto", marginTop: 10, gap: "20px" }}
        >
          <Col>
            <LazyImage
              src={p1}
              className="img-fluid"
              style={{ width: "80%", borderRadius: 10 }}
            />
          </Col>
        </Row>

        <Row
          className="text-center"
          style={{ width: "100%", margin: "auto", marginTop: 10, gap: "20px" }}
        >
          <Col>
            <LazyImage
              src={p2}
              className="img-fluid"
              style={{ width: "80%", borderRadius: 10 }}
            />
          </Col>
        </Row>

        <Row
          className="text-center"
          style={{ width: "100%", margin: "auto", marginTop: 10, gap: "20px" }}
        >
          <Col>
            <LazyImage
              src={p3}
              className="img-fluid"
              style={{ width: "80%", borderRadius: 10 }}
            />
          </Col>
        </Row>

        <Row
          className="text-center"
          style={{
            width: "100%",
            margin: "auto",
            marginTop: 10,
            marginBottom: 50,
            gap: "20px",
          }}
        >
          <Col>
            <LazyImage
              src={p4}
              className="img-fluid"
              style={{ width: "80%", borderRadius: 10 }}
            />
          </Col>
        </Row>

        <Row>
          <div
            className="mb-5 tnc-accordion"
            style={{ textAlign: "start", width: "80%", margin: "auto" }}
            ref={this.accordionRef}
          >
            <UncontrolledAccordion defaultOpen="1">
              <AccordionItem>
                <AccordionHeader targetId="1">
                  Terms and Conditions
                </AccordionHeader>
                <AccordionBody
                  accordionId="1"
                  style={{ backgroundColor: "#F8F8F8" }}
                >
                  <p>
                    <strong>SIMBA Celebrates SG60 Promotion</strong>
                  </p>
                  <ol>
                    <li>
                      SIMBA Telecom Pte. Ltd. (<strong>“SIMBA”</strong>) is the
                      organiser of this Promotion –
                      <strong>SG60 Promotion</strong> (the{" "}
                      <strong>“Promotion”</strong>). This Promotion is open from{" "}
                      <strong>
                        8 Aug 2025 00:00 hours to 17 Aug 2025 23:59 hours
                      </strong>
                      , Singapore time zone (<strong>“Promotion Period”</strong>
                      ), exclusively at SIMBA Service Centres and Authorised
                      Dealers only. Transactions done on SIMBA Website, App or
                      other unauthorised channels are not eligible for this
                      promotion.
                    </li>
                    <li>
                      These Terms and Conditions (<strong>“T&Cs”</strong>)
                      govern this Promotion.
                    </li>
                    <li>
                      By participating in this Promotion, you confirm that you
                      have read and understood these T&Cs and that you agree to
                      be bound by them. Any breach of these T&Cs will result in
                      the disqualification of your participation and the
                      forfeiture of any prize that you may have been awarded.
                    </li>
                  </ol>

                  <h5 style={{ fontWeight: 700 }}>A. Eligibility</h5>
                  <ol>
                    <li>
                      This Promotion is open to everyone in Singapore. However,
                      employees of SIMBA and their immediate family members are
                      not eligible to participate in this Giveaway.
                    </li>
                    <li>
                      To qualify, each participant must have a valid and active
                      SIM card with SIMBA.
                    </li>
                    <li>
                      SIMBA may at any time and in its absolute discretion
                      decide on or vary the eligibility requirements for
                      participation in this Promotion.
                    </li>
                    <li>
                      No third-party entries and/or bulk entries are eligible
                      for participation. SIMBA reserves the right to disqualify
                      any actual or suspected third-party entries and/or bulk
                      entries.
                    </li>
                    <li>
                      SIMBA reserves the right to verify the eligibility of each
                      participant and may require such information as it
                      considers reasonably necessary for the purpose of
                      verifying the eligibility of an entry. Any prizes that are
                      won by a participant may be withheld until and unless
                      SIMBA is satisfied with the verification.
                    </li>
                  </ol>

                  <h5 style={{ fontWeight: 700 }}>B. Promotion Mechanics</h5>

                  <ol>
                    <li>
                      For port-in promotion:
                      <p>
                        $20 SIMBA credits will be awarded to all subscribers
                        who:
                      </p>
                      <ol type="a">
                        <li>
                          Submit their port in request at the participating
                          locations between 8 to 17 August 2025; and
                        </li>
                        <li>
                          The port in is completed before 22 August 2025,
                          23:59PM.
                        </li>
                      </ol>
                      <p>
                        This promotion is only applicable to SIMBA postpaid and
                        prepaid mobile plans. The $20 SIMBA credits will be
                        credited into the subscriber's SIMBA wallet by 29 August
                        2025.
                      </p>
                      <p>
                        Credits cannot be exchanged for cash or other gifts.
                        SIMBA reserves the right to amend these terms and
                        conditions without prior notice. Other terms and
                        conditions apply.
                      </p>
                    </li>

                    <li>
                      For Recharge promotion:
                      <p>
                        $6 SIMBA credits will be awarded to all subscribers who
                        recharge $20 into their SIMBA wallet between 8 to 17
                        August 2025. Only recharges at the participating
                        locations are eligible for this promotion. The
                        promotional credits will be credited into the
                        subscriber's SIMBA wallet of the requisite recharge
                        amount.
                      </p>
                      <p>
                        Credits cannot be exchanged for cash or other gifts.
                        SIMBA reserves the right to amend these terms and
                        conditions without prior notice. Other terms and
                        conditions apply.
                      </p>
                    </li>

                    <li>
                      For SHARP AQUOS phone promotion:
                      <p>This promo ends 31 August 2025.</p>
                      <p>
                        SIMBA will strictly not be responsible for the purchase
                        of the SHARP mobile phone, and the purchaser will be
                        required to visit a SHARP Service Centre in order to
                        receive product support.
                      </p>
                      <p>
                        Credits cannot be exchanged for cash or other gifts.
                        SIMBA reserves the right to amend these terms and
                        conditions without prior notice. Other terms and
                        conditions apply.
                      </p>
                    </li>
                    <li>
                      Giveaway Mechanics
                      <ol>
                        <li>
                          To qualify for the Giveaway, participants must:
                          <ol type="a">
                            <li>
                              Be at least 16 years old at the start of the
                              Giveaway Period; and
                            </li>
                            <li>
                              Have a valid and active SIM card with SIMBA
                              during:
                              <ol type="i">
                                <li>The start of the Promotion Period;</li>
                                <li>The end of the Promotion Period;</li>
                                <li>The drawing of the prize winners;</li>
                                <li>The collection of the prize.</li>
                              </ol>
                            </li>
                            <li>
                              spend at least $60 at a participating location -
                              on qualifying purchases stated above in clauses 1
                              to 3, between 8 August 2025 00:00 hours to 17
                              August 2025 23:59 hours. Every $60 spent on
                              qualifying purchases shall be one (1) eligible
                              entry for the Giveaway. Any spending after the 17
                              August 2025 23:59 hours deadline will not be
                              eligible for entry into the Giveaway.
                            </li>
                          </ol>
                        </li>
                        <li>
                          60 winners will be chosen randomly at the end of the
                          Promotion Period. For avoidance of doubt, the
                          eligibility of all entries and awards are determined
                          in SIMBA's sole decision, which shall be final and
                          conclusive.
                        </li>
                        <li>
                          The winners will be announced on SIMBA's Instagram and
                          Facebook accounts on 29 August 2025, 16:00 hours.
                        </li>
                        <li>
                          The drawing of the winners will be done at SIMBA's
                          Kaki Bukit Service Centre ( 1 Kaki Bukit View #02-10,
                          Techview, Singapore 415941 ) on 25 August 2025, 14:00
                          hours.
                        </li>
                        <li>
                          All winners of the Giveaway will be contacted by SIMBA
                          through an SMS, and the winner must provide
                          identification verification details as required by
                          SIMBA in its absolute discretion for its review before
                          awarding the prize.
                        </li>
                        <li>
                          Each Participant is allowed to have multiple entries
                          into the Giveaway but will only be permitted to win
                          one prize from the Giveaway. If a Participant is drawn
                          for more than one prize, only the first prize drawn
                          for that Participant will be awarded, and any
                          subsequent prizes drawn for that same Participant will
                          be redrawn.
                        </li>
                        <li>
                          In the event any winner is not contactable within 2
                          weeks, SIMBA may redraw for another winner or donate
                          the unclaimed prize(s) as stated below, at SIMBA's
                          absolute discretion.
                        </li>
                      </ol>
                    </li>
                  </ol>

                  <h5 style={{ fontWeight: 700 }}>C. Giveaway Prizes</h5>
                  <ol>
                    <li>
                      There will be a total of sixty (60) winners for the
                      following Prizes (“Prizes”) with a total value of $9,317:
                      <ol type="I">
                        <li>1 x SHARP R10 smartphone (Worth $1099)</li>
                        <li>1 x SHARP 55" 4K UHD Smart TV (Worth $850)</li>
                        <li>
                          5 x 1 Year SIMBA Broadband Subscription (Worth $421
                          each)
                        </li>
                        <li>1 x SHARP AQUOS Wish5 smartphone (Worth $349)</li>
                        <li>
                          2 x SHARP AQUOS Wish4 smartphone (Worth $269 each)
                        </li>
                        <li>
                          2 x SHARP Plasmacluster Air Purifier (Worth $214 each)
                        </li>
                        <li>
                          10 x SHARP Wireless Earbuds HP-TW45 (Worth $199 each)
                        </li>
                        <li>2 x Huawei Watch Fit 2 (Worth $165 each)</li>
                        <li>1 x Huawei Watch Fit (Worth $128)</li>
                        <li>20 x SIMBA Credits (Worth $60 each)</li>
                        <li>15 x Sheng Siong Vouchers (Worth $20 each)</li>
                      </ol>
                    </li>

                    <li>
                      SIMBA reserves the right to redistribute any unclaimed
                      Prizes to other participants or to donate any unclaimed
                      Prizes to the Community Chest or any other approved
                      charitable organization as solely determined by SIMBA.
                    </li>

                    <li>
                      The Prizes, or any part thereof, shall not be
                      transferable, exchangeable, redeemable or substituted for
                      cash or other benefits.
                    </li>

                    <li>
                      If there are circumstances that are beyond SIMBA's control
                      which result in the unavailability or unfeasibility of any
                      Prize, SIMBA reserves the right to replace that Prize with
                      any other item of similar value without prior notice and
                      liability.
                    </li>
                  </ol>

                  <h5 style={{ fontWeight: 700 }}>
                    D. <strong>Collection</strong>
                  </h5>
                  <ol>
                    <li>
                      Upon the verification of each winner's identity, SIMBA
                      will send an SMS to the number that was used during the
                      recharge.
                    </li>
                    <li>
                      Prize collection will be at SIMBA's Office at 1 Kaki Bukit
                      View, #02-10, Techview, Singapore 415941. Winners must
                      bring along their NRIC or Passport for verification. A
                      winner may authorize a representative to collect on
                      his/her behalf and the representative must provide their
                      full details before collection. Prizes cannot be mailed or
                      delivered to winners.
                    </li>
                    <li>
                      If a Winner fails to collect the Prize within one (1)
                      month upon verification of winner's identity, the Winner
                      shall be deemed to have forfeited the Prize. No further
                      correspondence will be given or entertained under any
                      circumstances. In such an event, SIMBA management shall be
                      entitled to select another winner.
                    </li>
                    <li>
                      In the event that the prize incurs any tax liability, the
                      winner of the Prize shall be liable for the payment of
                      such tax.
                    </li>
                  </ol>

                  <h5 style={{ fontWeight: 700 }}>
                    E. <strong>Personal Data</strong>
                  </h5>
                  <ol>
                    <li>
                      SIMBA will need to collect and use participants' personal
                      data, as well as disclose their personal data to its
                      partners, to facilitate their participation in this
                      Giveaway. Such personal data may include without
                      limitation a participant's name, contact number, email
                      address, personal identification or passport number, as
                      well as his or her pictures, photographs or likeness.
                    </li>
                    <li>
                      Furthermore, given the nature of the Giveaway, the
                      Participants consent and authorise SIMBA and its partners
                      the right to use the names, pictures, photographs or
                      likeness of any participant or winner in their marketing,
                      publicity or promotional materials at their sole
                      discretion without notice to the participant or Winner for
                      marketing, publicity or promotional activities without any
                      further compensation (where not prohibited by law).
                    </li>
                    <li>
                      By participating in this Giveaway, participants consent to
                      SIMBA's and SIMBA's partners' collection, use and
                      disclosure of participants' personal data for the purposes
                      and in the manner described above and is subject to
                      SIMBA's{" "}
                      <a
                        href="https://www.simba.sg/data-protection-notice"
                        target="_blank"
                      >
                        Data Protection Notice
                      </a>{" "}
                      and{" "}
                      <a href="https://www.simba.sg/terms" target="_blank">
                        Standard Terms and Conditions
                      </a>
                      .
                    </li>
                  </ol>

                  <h5 style={{ fontWeight: 700 }}>
                    F. <strong>Others</strong>
                  </h5>
                  <ol>
                    <li>
                      SIMBA's decisions on the Giveaway and the Winners shall be
                      final and no correspondence will be entertained under any
                      circumstances. In the event of a dispute, an individual's
                      entitlement to participate in the Contest and a
                      participant's entitlement to the Prizes SIMBA shall have
                      the absolute discretion to review and award the Prizes.
                    </li>
                    <li>
                      SIMBA makes no warranty, assurances or guarantees as to
                      the Prizes and shall not be responsible to any Winner or
                      any person for the Prizes, including but not limited to
                      the redemption and use of the Prizes and the
                      specifications, defects or non-performance in the Prizes.
                      Any issue faced with the Prizes shall be resolved directly
                      with the merchant, provider or supplier of the Prizes.
                    </li>
                    <li>
                      SIMBA shall not be liable to any Winner or any person for
                      damages, losses, costs or expenses, including but not
                      limited to special, incidental, indirect, consequential,
                      punitive, lost profits, revenue, business or anticipated
                      savings suffered or incurred by any Winner or any person
                      arising out of or in connection with the redemption and
                      use of any Prize.
                    </li>
                    <li>
                      To the extent permissible by law, Participants (including
                      their heirs, parents, legal guardians, executor, and/or
                      administrators) shall hold harmless and indemnify SIMBA
                      and the SIMBA's agents against any and all liabilities,
                      losses, damages, claims, injury, actions, proceedings,
                      expenses and costs which may result in relation to the
                      Giveaway or the Prizes.
                    </li>{" "}
                    <li>
                      All intellectual property contained in any of the
                      materials related or used in connection with this Contest
                      including the prizes, are the property of their respective
                      owners. SIMBA and its affiliates and its contractors are
                      not affiliated with, or endorsed or sponsored by such
                      owners and their relevant affiliates. By participating in
                      this Contest, you grant SIMBA a non-exclusive, fully paid
                      and royalty-free worldwide, limited license to use,
                      modify, delete from, add to, publicly perform, publicly
                      display, reproduce and translate such your entry.
                    </li>
                    <li>
                      This Contest is not sponsored, endorsed or administered
                      by, or associated with Instagram.
                    </li>
                    <li>
                      SIMBA reserves the right to change, suspend or terminate
                      this Contest, or amend any of these terms and conditions
                      at any time, without notice and liability. Participation
                      in this Contest and continued use of SIMBA products and
                      services will constitute acceptance of these terms and
                      conditions and any amendments thereof.
                    </li>
                    <li>
                      These terms and conditions shall be governed by the laws
                      of Singapore. Where a dispute arises from the Contest or
                      this T&C, both SIMBA and the participant will use all
                      reasonable endeavors to amicably resolve any disputes
                      within 30 days. If the dispute is not resolved, the courts
                      of Singapore shall have exclusive jurisdiction to settle
                      any dispute arising out of or in connection with this
                      Contest or this T&C.
                    </li>
                  </ol>
                </AccordionBody>
              </AccordionItem>
            </UncontrolledAccordion>
          </div>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ state });
export default connect(mapStateToProps, null)(Sg60);
